<template>
    <div>
        <md-toolbar>
            <h3>Terms of Service and Privacy Policy</h3>
        </md-toolbar>
        <pre>
CREDOVITA FLAPP MATCH TERMS OF SERVICE AND PRIVACY POLICY
(OPERATING UNDER PRODUCT BRAND: FLAPP MATCH)
Terms of Service
(Ver 1.0 | 27 December 2019)
Credovita S.A.S. — Credovita Flapp Match
This Terms of Service (the "Terms of Service") between you and
Credovita S.A.S. ("Credovita," "Credovita Flapp Match", "Match",
“Flapp Match,” "we," "us," and/or "our") sets forth the legally
binding terms for your use of the website located at https://
flapp.credovita.io/ (including all the areas of the website
including the main site https://credovita.io) and any successor
websites, including any services, software, and applications made
available through such website (collectively, the "Site;"
“Platform;” “App;” and together with the Application, the
"Service"). By using the Service, you agree to the terms set forth
in this Terms of Service.
1. CREDOVITA FLAPP MATCH SERVICE
a. Description.
Credovita Flapp Match offers its users a platform to enter into both
interest-bearing direct personal loans with close degrees of
relation as well as non-interest bearing personal or small noncommercial business loans with friends and family. The interactions
are then managed by Credovita Flapp Match as deal flow manager and
financial logistics mechanism with deep integration with 3rd party
payment rails and legal service providers. The platform exists in
web application form, and mobile application form that uses a
variety of login and signup methods including but not limited to
services, APIs, and SDKs provided for by Facebook, Inc., its
subsidiaries, and its partners.
Direct F2F Loans (Friend/Family to Friend/Family Loans)
The Service offered by Credovita Flapp Match provides users with a
platform to facilitate funding directly made between peers of a
specific close level of intimacy — specifically identifiable as
friends and family for direct personal (“Direct F2F Loans”) loans
that are intended to be used for personal, family or household
purposes between a borrower and one or more lenders with whom the
borrower has an existing personal relationship, as well as to track
the accrual of interest with respect to such Direct Loans, and send
notifications pertaining to the Direct F2F Loans. Direct F2F Loans
generated through Credovita Flapp Match may also be allocated and
intended to be personal loans for commercial or consumer purposes,
but are not for the general use of a business enterprise or to
finance substantial investments. The Service offered by Credovita
Flapp Match also provides users with a platform to facilitate
funding from family and friends for direct personal gifts, ie. zero
interest loans or loans with no due date that are intended to be
used for personal, family or household purposes. This service may
only be used by natural legal persons.
For purposes of these Terms of Service, “Direct F2F Loans” and any
else that may be integrated into the platform with explicit
labelling as loans, are and will be referred to collectively as
“Loans”; persons and businesses borrowing through the Service are
referred to individually as a “Borrower” and collectively as
“Borrowers”; and persons lending through the Service (whether as a
lender for a Direct F2F Loan or any other type) are referred to
individually as a “Lender” and collectively, as “Lenders”.
b. Credovita S.A.S. and Credovita Flapp Match Are Not Lenders; All
Financial Risks Are Yours.
Credovita S.A.S. and the Credovita Flapp Match Platform are not
lenders and are not regulated financial institutions. Credovita does
not underwrite or otherwise provide security, assurances or
guarantees with respect to the Loans. Credovita only provides the
Service, which is a social solution for establishing Loans with
other users. Loans generated through Credovita Flapp Match are not
created for investment purposes and have not been registered under
any securities regulations, as amended or the securities laws of any
jurisdiction. Credovita is not providing services related to the
issuance of securities. Credovita disclaims all responsibility for
financial risks resulting from the Loans and you are responsible for
all financial risks related to any Loans established as a
consequence of the use of the Service, including, but not limited to
being responsible for any collections activity that may be required,
including but not limited to litigation in court to obtain
repayment.
c. Additional Risks Relating to Your Use of the Service.
CREDOVITA DOES NOT ASSESS THE IDENTITY OR CREDITWORTHINESS OF
BORROWERS ON THE SERVICE. IT IS THE SOLE RESPONSIBILITY OF EACH
LENDER TO CONDUCT HIS/HER OWN EXAMINATION OF A BORROWER WHEN
DETERMINING WHETHER TO OFFER TO FUND A LOAN. In addition, Credovita
has no control over and does not guarantee the truth or accuracy of
information logged on the Service by any users or the ability or
intent of any Borrower to repay a Loan. All Loans are direct
agreements between Borrowers and Lenders. Borrowers and Lenders are
responsible for compliance with all laws associated with the use of
the Services.
d. Your Acceptance Of These Risks.
Sections 1(b) and 1(c) above describe the risks that you assume when
using the Service. If you have any kind of dispute with one or more
users (including, but not limited to disputes, involving
intellectual property, defamation, collections, or any violation of
law by any user), you release us (and our affiliates and
subsidiaries, and our and their respective officers, directors,
employees, agents, investors, mentors, and advisors) from claims,
demands and damages (actual and consequential) of every kind and
nature, known and unknown, arising out of or in any way connected
with such disputes. In entering into this release you expressly
waive any protections (whether statutory or otherwise) that would
otherwise limit the coverage of this release to include only those
claims, which you may know or suspect to exist in your favour at the
time of agreeing to this release.
e. Modifications.
Credovita reserves the right to (i) perform maintenance to the
Service due to technology improvements or bugs, and you may or may
not be notified of these changes before they occur and (ii) modify,
update, or discontinue, temporarily or permanently, the Service (or
any part thereof) at any time, with or without notice, in
Credovita’s sole discretion. To keep the Credovita Flapp Match
Application and Platform up-to-date, we may offer automatic or
manual updates at any time and without notice to you. You agree that
Credovita will not be liable to you or to any third party for any
modification, update, or discontinuation of the Service.
f. Fees.
For Direct F2F Loans, Credovita currently charges a tranched
transaction model based on usage and complexity of the transaction
in addition to any ancillary fees charged to Credovita by our
authorised 3rd party partners for services and products of theirs
interacted with in relation to the transaction of the customer, and
Credovita also provides a fixed rate option for certain kinds of
transaction. These fees, rates, and ancillary services can be found
at https://credovita.io/flapp/pricing. Credovita reserves the right
to charge a fee for the Service at any time and for any reason. If
Credovita decides to increase charges for the Service, it will amend
this Terms of Service to reflect the new fee, and the amended Terms
of Service will be effective upon the posting of the new Terms of
Service on the Site or through a public posting of a service brief
announcement. Credovita will also provide existing customers with
reasonable advance notice of any new fees, except in the case of
force majeure.
2. ACCESS TO THE SERVICE
a. Eligibility.
To use our Service, you must register for an account with Credovita
and provide certain information. You must be at least 18 years old
(but a special case may be made for minors if they contact Credovita
prior to use of service) to use the Service. By registering for and
using the Service, you represent and warrant that (i) all
registration information you submit is truthful and accurate; (b)
you will maintain and update such registration information to keep
it current, truthful, and accurate; (c) you are at least 18 years
old (or a minor depending on the discretion of Credovita); (d) your
use of the Service is for personal, household or family purposes
only; (e) your use of the Service is not to facilitate transactions
that are illegal or involve gambling, including, but not limited to,
using the funds to hire sex workers, buy illegal substances or
otherwise commit a criminal act; and (f) you are not currently
suspended by Credovita or any other online payments service or
similar platform from using the Service or their corresponding
services. (h) you agree to conform to all the necessary Know-YourCustomer (“KYC”) and Anti-Financing of Terrorism (“AFT”) regulations
in the judicial locales wherein you reside and the judicial locale
wherein Credovita operates. By interacting with the platform you
will be considered as bound by the terms of this agreement.
b. Lack of Access
Without limiting any other remedies available, we may at any time,
with or without notice to you, and in our sole discretion, refuse to
provide, limit, suspend, or terminate your use of the Service, your
user account, and/or your activities on the Service and take any
technical and legal steps to keep you from using our Service. This
Terms of Service will remain in effect after any such action has
been taken. You agree that Credovita will not be liable to you or
any third-party for any limitation, suspension, or termination of
your access to the Service.
c. Registration.
You may register for the Service directly within the Service. You
are only authorised to create and use one account for the Service
and are prohibited from using alter egos or other disguised
identities when using the Service. If we discover that you have
multiple accounts with the Service, then all accounts will be closed
immediately. You may also register for the Service using certain
third party services that can be directly integrated into the
Service on an as available basis.
d. Use of Your Address Book and Personal Information.
You expressly acknowledge and agree that in order to provide the
Service, your contact information will be saved from the sign-up
service that you choose to use (Facebook, LinkedIn, etc.) and that
profile authentication may be used to gather more information about
your profile from those services. You hereby give your express
consent to such use of your address book and sign-up service. You
also agree that we can collect, use, share and retain the
information collected from your address book for our business
purposes as described in our Privacy Policy and that we may retain
such information for archival purposes and if required by law; in
addition Credovita reserves the right to use and commercialise for
its own purposes the data, videos, information, images, and other
accessible data points collected by your use of our service for the
purpose of developing, improving, and commercialising the platform,
you the user reserve the right to control the use of your data in
compliance with the relevant data privacy regulations in the
jurisdictions where Credovita operates. For more information please
refer to the Privacy Policy.
e. Account Login Information and Security.
When you create an account with Credovita, you will also be asked to
input account login information. You are responsible for maintaining
the confidentiality of such login information and should protect it
from disclosure to others. You agree not to use the account login
information of any other user or to disclose your account login
information to any third party. You agree to notify Credovita
immediately if you suspect any unauthorised use of your account or
any other breach of security within the Service. You are solely
responsible for any and all use of your account, and Credovita will
not be liable for your losses caused by any unauthorised use of your
account. If you use a password that Credovita considers insecure,
Credovita is entitled to require the password to be changed and/or
to terminate your account. Although we provide a secure environment
for the Service, no technology can provide complete security in the
online environment, and we are not responsible to you for
unauthorised intrusions by outside parties to the Service.
f. Communications and Notifications to You.
By creating an account with Credovita and providing your email
address, phone number, and/or other contact information to us, you
agree that this action constitutes a purchase or inquiry
establishing a business relationship with us. You agree to provide
accurate and complete information to Credovita during the account
registration process. You expressly consent to our use of your email
address, phone number, and other contact information to send you
updates and communications about our products and services or other
messages, such as newsletters, changes to features of the Service,
or special offers. You may control receipt of marketing messages
from us by clicking on the unsubscribe link included in those
messages; however, you may not opt out of receiving account and
servicing messages from us. You also represent and warrant that you
have the legal authority over any telephone number you provide to us
and have the right to provide us with the authorisation to contact
you. This means we may contact you, in person or by recorded
message, by social media or instant messenger, e-mail, telephone
and/or mobile telephone number (including use of automated dialing
equipment), text (SMS) message both human initiated and automated,
or any other means of communication that your wireless or other
telecommunications device may be capable of receiving. If you change
or deactivate your mobile telephone number, you agree to promptly
update your Credovita with your account information to ensure that
your messages are not sent to the person that acquires your old
number or other personal alias.
g. User Identity, Creditworthiness, and Use of Funds.
While using our Service, you take full responsibility for your
interactions among users. Credovita provides a platform to assist
your interactions with other users of our Service but Credovita is
not involved in verifying the purported identity or the
creditworthiness of its users, or in verifying the use of funds
loaned to any user. The third-party service provider that allows you
to transfer and pay funds will require verification of your
identity, and the identity of other users. However, Credovita
disclaims all responsibility for the verification of any user by the
third-party service provider. Credovita may attempt, but is under no
obligation, to independently verify a user's purported identity. The
verification of identity by the third-party service provider is not
used to identify the creditworthiness of your users, and the thirdparty service provider's CIP verification procedures are not
intended to be used in lieu of other fraud protection.
h. Deactivate Service.
If you no longer wish to use the Service, send an email to
team@credovita.io requesting deactivation cancellation of any ongoing services you are subscribed to within a reasonable timeframe.
We may still retain certain information associated with your account
for analytical purposes and recordkeeping integrity, as well as to
prevent fraud, resolve disputes, enforce this Terms of Service, and
take actions we deem necessary due to technical and legal
requirements and constraints related to the security, integrity and
operation of the Application or the Service. Credovita is bound to
comply with the relevant data privacy regulations of the markets and
judicial locales it operates in.
3. APPLICATION
a. License; Scope.
Subject to the terms and conditions of this Terms of Service, we
grant you a non-exclusive, revocable, limited license, to the
Application, for your personal, non-commercial purposes. For
clarity, the Application is being licensed, not sold, to you. We
reserve all rights not expressly granted to you. This license does
not allow you to use the Application on any other device that you do
not own or control, and you may not distribute or make the
Application available over a network where it could be used by
multiple devices at the same time. You may not rent, lease, lend,
sell, redistribute or sublicense the Application. You may not copy
(except as expressly permitted by this license), decompile, reverse
engineer, disassemble, attempt to derive the source code of, modify,
or create derivative works of the Application or any part thereof
(except as and only to the extent any foregoing restriction is
prohibited by applicable law or to the extent as may be permitted by
the licensing terms governing the use of any open sourced components
included with the Application). Any attempt to do so is a violation
of the rights of Credovita and its licensors. If you breach this
restriction, you may be subject to prosecution and damages. The
terms of the license will govern any upgrades provided by us that
replace and/or supplement the original Application, unless such
upgrade is accompanied by a separate license in which case the terms
of that license will govern.
b. Personal Use
The Service and any portion thereof, including any Credovita Content
contained therein, are intended for your personal, noncommercial use
in accordance with this Terms of Service. You agree that you will
not, unless specifically permitted by us (i) copy, display or
distribute any part of the Credovita Content or Service, in any
medium, without our prior written consent, or (ii) alter or modify
any part of the Service other than as may be reasonably necessary to
use the Service for its intended purpose. You will not use any
automated devices, such as spiders, robots or data mining
techniques, to catalog, download, store, reproduce, or distribute
Credovita Content available on the Service or to manipulate the
Service in any manner not consistent with its intended purpose(s).
Illegal and/or unauthorised use of the Service, including collecting
names and/or email addresses of users by electronic or other means
for the purpose of sending unsolicited email or unauthorized framing
of or linking to the Service is prohibited. Appropriate legal action
may be taken for any illegal or unauthorised use of the Service.
c. Compliance with Laws
You agree not to use the Service, in whole or in part, for any
purpose that is unlawful. The Service is subject to, and you agree
that you will at all times comply with all local, city, state, and
national laws, statutes, rules, regulations, ordinances and the like
that may be applicable to your use of the Service.
d. Termination
Your rights under the license to the Application will terminate
automatically without notice from Credovita if you fail to comply
with any term(s) of the license or this Terms of Service. Upon
termination of the license, you will cease all use of the
Application, and delete all copies, full or partial, of the
Application.
e. Advertisements.
You understand and agree that the Application may include
advertisements and that such advertisements are necessary for
Credovita to provide the Application to you. By accepting these
Terms of Service you expressly allow Credovita to use your data for
commercial and advertising purposes.
f. Support Services.
Credovita may, in its sole discretion, provide you with support
services related to the Service or any portion thereof ("Support
Services"). However, Credovita is not required to provide Support
Services to you. No failure to provide, or to continue to provide,
Support Services will be a default by Credovita in this Terms of
Service.
g. Payment Services
If you opt to use Credovita Payment Services, including but not
limited to those associated with the transfer of funds from one user
to another, you must consent and interact with the services of an
authorised and verified 3rd party working with Credovita. As of this
Alpha Test, this section shall be updated to reflect future updates.
4. USER CONTENT
a. Responsibility.
You are solely responsible for ensuring the User Content you send
complies with Section 5, below. Credovita does not endorse and has
no control over the User Content you post, or any user posts, on the
Service. User Content is not necessarily reviewed by Credovita prior
to posting and does not reflect the opinions or policies of
Credovita. Credovita makes no warranties, express or implied, as to
the User Content or to the accuracy and reliability of the User
Content or any material or information that you transmit, or any
other user transmits, to other users. Credovita assumes no
responsibility for monitoring the Service for inappropriate User
Content, but please review information about copyrights, below. If
at any time Credovita chooses, in its sole discretion, to monitor
the Service, Credovita nonetheless assumes no responsibility for the
User Content, has no obligation to modify or remove any
inappropriate User Content, and has no responsibility for the
conduct of the user posting any such User Content. Notwithstanding
the foregoing, Credovita may delete any User Content that, in the
sole judgment of Credovita, violates this Terms of Service or that
may be offensive, illegal or violate the rights, harm, or threaten
the safety of any person or for any other reason. Your failure to
comply with User Content obligations is also a basis for termination
of your use of the Service and the removal of any and all User
Content you may have posted. It is however strictly prohibited to
use the Credovita Flapp Match service to advertise or promote
activities and services that are explicitly illegal in the locations
and jurisdictions wherein Credovita operates.
b. Ownership.
By providing User Content to us or posting it on the Service, you
represent and warrant that you own such User Content or otherwise
have the right to grant us the license set forth in Section 4(c),
that the User Content is accurate and not confidential and the
submission, transmission, posting and use of your User Content on
the Service is not in violation of any applicable laws or
contractual restrictions or other third party rights (including,
without limitation, privacy, publicity, and intellectual property
rights).
c. License.
By providing your User Content to Credovita or otherwise submitting,
transmitting, or displaying your User Content on or through the
Service, you automatically grant (and you represent and warrant that
you have the right to grant) to Credovita, and Credovita’s
licensees, and their respective successors in business and assigns,
officers, directors, employees, licensees, agents, representatives
and other users of the Service, a worldwide, sub-licenseable,
assignable, perpetual, irrevocable, non-exclusive, royalty-free,
unlimited right and license to use, reproduce, publish, distribute,
publicly display, broadcast and perform, reformat, adapt, modify and
delete your User Content in connection with the Service in any
medium now existing or hereinafter developed, and to use your user
name and any personal information you submit with or contained
within the User Content, consistent with our Privacy Policy, but
without your prior approval or the payment of any compensation and
without notice ("License"). This License will enable each user of
the Service to access your User Content as permitted through the
functionality of the Service and under this Terms of Service. This
License includes the right to filter, modify or adapt your User
Content in order to transmit, display or distribute it over computer
networks and to allow third parties to access your User Content
through the Service, as provided in this Terms of Service. Posting
of User Content to the Service does not confer any rights of access
to or ownership of the Service. As noted, this License is nonexclusive (so you can license your User Content to others),
worldwide (as the Internet is global in its reach), fully-paid up
and royalty-free (so that we do not have to pay you for posting your
User Content) and sub-licenseable through multiple tiers (so that we
can use our service providers or others to provide our Service).
d. Storing and Disclosure; Transmission.
You acknowledge and agree that Credovita may store your User Content
and may also disclose your User Content if required to do so by law
or in the good faith belief that such storage or disclosure is
reasonably necessary to: (i) comply with legal process, applicable
laws or government requests; (ii) enforce this Terms of Service;
(iii) respond to claims that any content violates the rights of
third parties; or (iv) protect the rights, property, or personal
safety of Credovita, its users and the public. You understand that
the technical processing and transmission of the Service, including
your User Content, may involve transmissions over various networks
and changes to conform and adapt to technical requirements of
connecting networks or devices. It is possible for an outside
website or a third party to re-post your User Content, and you agree
to hold LoanWell harmless for any dispute concerning such use. We
reserve the right to withhold, remove and or discard any content
stored by the Service, including any User Content that you or other
users post on the Service, your usage history on the Service,
registration information, login information or any other
information, with or without notice, for any reason in our sole
discretion. For avoidance of doubt, Credovita has no obligation to
store, maintain or provide you a copy of any User Content that you
or other users post on the Service, your usage history on the
Service, registration information, login information or any other
information. You acknowledge that, notwithstanding any copyright or
other rights you may have with respect to User Content, and
notwithstanding any value attributed to such User Content or other
data by you or any third party, CREDOVITA DOES NOT PROVIDE OR
GUARANTEE, AND EXPRESSLY DISCLAIMS (SUBJECT TO ANY UNDERLYING
INTELLECTUAL PROPERTY RIGHTS IN THE USER CONTENT), ANY VALUE, CASH
OR OTHERWISE, ATTRIBUTED TO ANY DATA RESIDING ON ITS SERVERS.
5. PROHIBITED CONTENT AND ACTIVITIES
Your use of the Service is subject to all applicable laws and
regulations, and you are solely responsible for the substance of any
User Content you post, and your conduct, on the Service. The
following are examples of the kind of User Content and items that
are illegal or prohibited to be posted on or through the Service.
Credovita reserves the right to investigate and take appropriate
legal action against anyone who, in Credovita’s sole discretion,
violates any of these provisions, including, without limitation,
removing the offending User Content or items from the Service,
suspending or terminating the account of such violators, and
reporting violators to the law enforcement authorities.
a. Prohibited User Content includes, but is not limited to, User
Content that in the sole discretion of Credovita:
is offensive or promotes racism, bigotry, hatred or physical harm of
any kind against any group or individual;
harasses or advocates harassment of another person;
exploits people in a sexual or violent manner;
contains nudity, violence, or offensive subject matter or contains a
link to an adult website;
constitutes financial advice of any kind, including tax advice or
advice on securities or trading;
promotes information that you know is false or misleading or
promotes illegal activities or conduct that is abusive, threatening,
obscene, defamatory or libelous;
contains hyperlinks, "hidden" keywords or keywords that are
irrelevant to the Service or are otherwise misleading;
involves any franchise, pyramid scheme, "club membership",
distributorship or sales representative agency arrangement or other
business opportunity that requires an upfront or periodic payment,
pays commissions only, or requires recruitment of other users, subdistributors or sub-agents;
promotes an illegal or unauthorised copy of another person's
copyrighted work, such as providing pirated computer programs or
links to them, providing information to circumvent manufactureinstalled copy-protect devices, or providing pirated music or links
to pirated music files;
involves the transmission of "junk mail," "chain letters," or
unsolicited mass mailing, instant messaging, "spimming," or
"spamming";
contains restricted or password-only access pages or hidden pages or
images (those not linked to or from another accessible page);
furthers or promotes any criminal activity or enterprise or provides
instructional information about illegal activities including, but
not limited to making or buying illegal weapons, violating someone's
privacy, or providing or creating computer viruses;
solicits passwords or personal identifying information for
commercial or unlawful purposes from other users;
involves commercial activities and/or sales without our prior
written consent such as contests, sweepstakes, advertising, or
pyramid schemes;
you did not create or that you do not own all right, title and
interest in and to, including, without limitation, all copyright and
rights of publicity contained therein;
infringes or misappropriates any third party's patent, trademark,
service mark, copyright, moral rights, trade secrets or other
intellectual property; or
invades or violates any third party's right to privacy.
b. In addition, the following are examples of the kind of activity
that is illegal or prohibited on the Service. Credovita reserves the
right to investigate and take appropriate legal action against
anyone who, in Credovita’s sole discretion, violates any of these
provisions, including, without limitation, suspending or terminating
the account of such violators, and reporting violators to the law
enforcement authorities. Prohibited activities include, without
limitation:
criminal or tortious activity, including child pornography, fraud,
trafficking in obscene material, drug dealing, gambling, harassment,
stalking, spamming, spimming, sending of invalid data, worms,
viruses or other harmful files, copyright, trademark, or patent
infringement, or theft of trade secrets;
transmitting any chain letters or junk email to other users and
using any information obtained from the Service in order to directly
contact, advertise to, solicit, or sell to any user outside the
Service without such user's prior explicit consent;
any automated use of the system, such as using scripts to follow
users or send comments or messages;
interfering with, disrupting, or creating an undue burden on the
Service or the networks or services connected to the Service;
attempting to impersonate another person or posting any third
party's information on the Service without permission;
using the account, username, or password of another user at any time
or disclosing your password to any third party or permitting any
third party to access your account;
selling or otherwise transferring your Credovita account;
aggregating, copying, or duplicating in any manner all or part of
the Service or information available from the Service, without
express written consent from Credovita;
using any information obtained from the Service in order to harass,
abuse, or harm another person;
accepting payment or anything of value from a third person in
exchange for your performing any commercial activity on or through
the Service on behalf of that person, such as posting blogs,
Newsfeed items, or bulletins with a commercial purpose;
using the Service in a manner inconsistent with any and all
applicable laws and regulations;
using or launching any automated system, including without
limitation, "robots," "spiders," "offline readers," etc., that
access the Service in a manner that sends more request messages to
the Service servers than a human can reasonably produce in the same
period by using a conventional on-line web browser;
collecting or harvesting any personally identifiable information,
including names or email addresses, from the Service, or use the
Service for any commercial solicitation purposes without prior
written consent from Credovita;
renting, leasing, transferring, selling, reselling, or otherwise
exploiting for any commercial purpose, any portion of or access to
the Service;
using the Service to solicit business or to support any business or
commercial activities;
selling an item you do not have the right to sell; or
advertising or offering to sell or buy any items other than those
items intended to be sold and purchased through the Service;
Using the Credovita platform or related services expressly to copy
and compete with the company or sell this information by stealing
its intellectual property and trade secrets.
6. PROPRIETARY RIGHTS
a. User Feedback.
You acknowledge and agree that any questions, comments, suggestions,
ideas, feedback or other information you provide to Credovita about
the Service ("Submissions") are non-confidential and Credovita will
be entitled to the unrestricted use and dissemination of these
Submissions for any purpose, commercial or otherwise, without
acknowledgment or compensation to you.
b. Credovita Content.
The Service contains information, files, images, photos, video,
sounds, musical works, works of authorship, and other materials
created by or on behalf of Credovita and published by Credovita in
connection with the Service (collectively, "Credovita Content").
LoanWell solely owns all rights, title, and interest in and to the
Credovita Content, including but not limited to graphics, design,
compilation, computer code, products, Application, visual
interfaces, interactive features, and all other elements and
components of the Service. Credovita Content is protected by
copyright, trademark, patent, trade secret and other laws, and
Credovita owns or licenses and retains all rights in the Credovita
Content and the Service. Credovita hereby grants you a limited,
revocable, non-sub-licensable license to reproduce and display the
Credovita Content (excluding any software code) solely for your
personal non-commercial use in connection with using the Service in
accordance with this Terms of Service. You agree not to copy,
modify, translate, publish, broadcast, transmit, distribute,
perform, display, frame, scrape, rent, lease, loan, sell, or create
derivative works based on any content posted on the Service by any
other users, the Credovita Content, or the Service. Any use of the
Service or the Credovita Content other than as specifically
authorised herein is strictly prohibited. You agree not to reverse
engineer, reverse assemble or otherwise attempt to discover any
source code, sell, assign, sublicense, or otherwise transfer any
right in the Service (including the Application). Any rights not
expressly granted herein are reserved by Credovita.
c. Trademarks.
Certain graphics, logos, page headers, button icons, scripts, and
service names located on the Service are trademarks, registered
trademarks, or trade dress of Credovita (collectively the "Credovita
Trademarks"). Credovita’s trademarks and trade dress may not be used
in connection with any non-Credovita product or service, in any
manner that is likely to cause confusion among customers, or in any
manner that disparages or discredits Credovita. All other trademarks
not owned by Credovita that appear on this site are the property of
their respective owners, who may or may not be affiliated with,
connected to, or sponsored by Credovita. Nothing in this Terms of
Service or the Service should be construed as granting, by
implication, estoppel, or otherwise, any license or right to use any
Credovita Trademarks or third-party trademarks or service marks
displayed on the Service, without our prior written permission. All
goodwill generated from the use of Credovita Trademarks will inure
to Credovita’s exclusive benefit.
7. COPYRIGHT POLICY
a. General.
Credovita respects the legal rights of others, and we ask that our
users do the same. It is the policy of Credovita to terminate the
right of a user to use the Service if such user repeatedly infringes
the copyright rights of others upon receipt of prompt notification
to Credovita by the copyright owner or the copyright owner's legal
agent.
b. Infringement Notice.
If you believe that your work has been copied and posted on the
Service in a way that constitutes copyright infringement, to comply
with the relevant regulations, you must provide Credovita’s
designated copyright agent or the company itself via a contact form
available on the Credovita Website set forth below with the
following information: (i) an electronic or physical signature of
the person authorized to act on behalf of the owner of the copyright
interest; (ii) a description of the copyrighted work that you claim
has been infringed; (iii) a description of where the material that
you claim is infringing is located on the Service; (iv) your
address, telephone number, and email address; (v) a written
statement by you that you have a good faith belief that the disputed
use is not authorised by the copyright owner, its agent, or the law;
(vi) a statement by you, made under penalty of perjury, that the
above information in your notice is accurate and that you are the
copyright owner or authorised to act on the copyright owner's
behalf. Please note that this procedure is exclusively for notifying
Credovita that your copyrighted material has been infringed.
c. Counter-Notice.
We may provide a user with notice that we have removed or disabled
access to certain content by means of a general notice on the Site,
electronic mail to the user's e-mail address in our records, or by
written communication sent by first-class mail to the user's
physical address in our records. If you receive such a notice, you
may provide counter-notification in writing to Credovita’s
designated copyright agent or designated person set forth below that
includes the information below. To be effective under the relevant
regulations, the counter-notification must be a written
communication that includes the following: (a) your physical or
electronic signature; (b) identification of the material that has
been removed or to which access has been disabled, and the location
at which the material appeared before it was removed or access to it
was disabled; (c) a statement from you under the penalty of perjury,
that you have a good faith belief that the material was removed or
disabled as a result of a mistake or misidentification of the
material to be removed or disabled; and (d) your name, physical
address and telephone number, and a statement that you consent to
the jurisdiction of the Grand Duchy of Luxembourg, or any judicial
district in which Credovita may be found, and that you will accept
service of process from the person who provided notification of
allegedly infringing material or an agent of such person.
d. Copyright Agent.
Credovita’s copyright agent and designated person for notice of
claims of copyright infringement can be contacted as follows:
Credovita S.A.S., Attn: Copyright Agent and Data Privacy Officer 29,
Boulevard Grande-Duchesse Charlotte, Luxembourg City, L-1331. Carbon
Copy an email to DPO@credovita.io
8. DISCLAIMERS
CREDOVITA, AND ITS OFFICERS, AGENTS, REPRESENTATIVES, EMPLOYEES, AND
AFFILIATES (COLLECTIVELY, "AFFILIATES"), ARE NOT RESPONSIBLE FOR ANY
INCORRECT OR INACCURATE CONTENT (WHETHER USER CONTENT OR CREDOVITA
CONTENT) POSTED ON THE SERVICE, WHETHER CAUSED BY USERS OF THE
SERVICE, OUR ADVERTISERS OR CORPORATE PARTNERS, OR BY ANY OF THE
EQUIPMENT OR PROGRAMMING ASSOCIATED WITH OR UTILISED IN THE
OPERATION OF THE SERVICE.
CREDOVITA AND ITS AFFILIATES ARE NOT RESPONSIBLE FOR THE CONDUCT,
WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE SITE OR THE SERVICE,
INCLUDING, WITHOUT LIMITATION, FOR ANY USER'S FAILURE TO PAY A DEBT
TO ANOTHER USER OR MISREPRESENTATION REGARDING THE NATURE OF THE
FINANCIAL TRANSACTION UNDERTAKEN VIA THE SERVICE.
UNDER NO CIRCUMSTANCES WILL CREDOVITA AND ITS AFFILIATES BE
RESPONSIBLE FOR ANY LOSS OR DAMAGE, INCLUDING LOST DATA, LOST
INFORMATION, PERSONAL INJURY OR DEATH, RESULTING FROM ANYONE'S USE
OF THE SERVICE, ANY CONTENT POSTED ON THE SERVICE OR TRANSMITTED TO
USERS, OR ANY INTERACTIONS BETWEEN OR AMONG USERS OF THE SERVICE,
WHETHER ONLINE OR OFFLINE, WHETHER ON THE SERVICE OR ELSEWHERE.
CREDOVITA AND ITS AFFILIATES ASSUME NO RESPONSIBILITY FOR ANY ERROR,
OMISSION, INTERRUPTION, DELETION, DEFECT, DELAY IN OPERATION OR
TRANSMISSION, COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION OR
UNAUTHORISED ACCESS TO, OR ALTERATION OF, USER COMMUNICATIONS ON THE
SERVICE AND ARE NOT RESPONSIBLE FOR ANY PROBLEMS OR TECHNICAL
MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ONLINE
SYSTEMS, SERVERS OR PROVIDERS, COMPUTER EQUIPMENT, SOFTWARE, FAILURE
OF E-MAIL OR PLAYERS ON ACCOUNT OF TECHNICAL PROBLEMS OR TRAFFIC
CONGESTION ON THE INTERNET OR AT ANY WEBSITE OR COMBINATION THEREOF.
CREDOVITA AND ITS AFFILIATES ARE NOT RESPONSIBLE FOR ANY INJURY OR
DAMAGE TO ANY COMPUTER EQUIPMENT BELONGING TO ANY USER OF THE
SERVICE OR ANY OTHER PERSON RELATED TO OR RESULTING FROM THE USE OF
THE SERVICE, VIEWING, PLAYING OR DOWNLOADING ANY MATERIALS ON OR
FROM THE SERVICE, OR OTHERWISE IN CONNECTION WITH THE SERVICE.
THE SITE, THE SERVICE, AND THE TRANSACTIONS FACILITATED THROUGH THE
SERVICE ARE PROVIDED "AS-IS" AND "AS AVAILABLE" AND, EXCEPT AS
OTHERWISE PROHIBITED BY APPLICABLE LAW, CREDOVITA EXPRESSLY
DISCLAIMS ANY WARRANTY OF ANY KIND, INCLUDING, BUT NOT LIMITED TO
WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
NON-INFRINGEMENT, OR THAT THE SERVICE WILL BE AVAILABLE AT ANY
PARTICULAR TIME OR LOCATION, UNINTERRUPTED OR SECURE, OR THAT ANY
DEFECTS OR ERRORS WILL BE CORRECTED, OR THAT THE SERVICE IS FREE OF
VIRUSES OR OTHER HARMFUL COMPONENTS. YOU EXPRESSLY ACKNOWLEDGE AND
AGREE THAT YOUR USE OF THE SERVICE OR ANY PORTION THEREOF IS AT YOUR
SOLE RISK (INCLUDING, WITHOUT LIMITATION, ANY LOSS OF DATA OR OTHER
DAMAGE TO YOUR COMPUTER OR OTHER DEVICE YOU EXPERIENCE FROM USING
THE SERVICE) AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY,
PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU. CREDOVITA DOES NOT
GUARANTEE ANY SPECIFIC RESULTS FROM YOUR USE OF THE SERVICE. IF YOU
ARE DISSATISFIED WITH ANY OF PART OF THE SERVICE OR WITH THE TERMS
OF THIS TERMS OF SERVICE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
DISCONTINUE ACCESSING AND USING THE SERVICE.
THE SERVICE MAY CONTAIN LINKS TO THIRD-PARTY WEBSITES THAT ARE NOT
OWNED OR CONTROLLED BY CREDOVITA. CREDOVITA HAS NO CONTROL OVER, AND
ASSUMES NO RESPONSIBILITY FOR, THE CONTENT, POLICIES, OR PRACTICES
OF ANY THIRD-PARTY WEBSITES. YOU EXPRESSLY RELIEVE CREDOVITA FROM
ANY AND ALL LIABILITY ARISING FROM YOUR USE OF ANY THIRD-PARTY
WEBSITE OR SERVICE. CREDOVITA DOES NOT WARRANT, ENDORSE, GUARANTEE,
OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
OFFERED BY A THIRD PARTY THROUGH THE SERVICE OR ANY HYPERLINKED
WEBSITE, OR FEATURED IN ANY BANNER OR OTHER ADVERTISING. CREDOVITA
WILL NOT BE A PARTY TO OR IN ANY WAY MONITOR ANY TRANSACTION BETWEEN
YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
CREDOVITA MAY IN ITS SOLE DISCRETION, BUT IS NOT OBLIGATED TO,
PREVIEW, REVIEW, SCREEN, OR REMOVE USER CONTENT ON THE SERVICE. YOU
MAY BE EXPOSED TO USER CONTENT OR CREDOVITA CONTENT THAT IS
INACCURATE, OFFENSIVE, INDECENT, OBJECTIONABLE, INFRINGING, AND YOU
HEREBY AGREE TO WAIVE ANY LEGAL RIGHTS AND REMEDIES YOU MAY HAVE
AGAINST CREDOVITA FOR SUCH EXPOSURE.
9. CREDOVITA LIMITATION OF LIABILITY
IN NO EVENT WILL CREDOVITA AND ITS AFFILIATES BE LIABLE TO YOU OR
ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, INCLUDING, WITHOUT
LIMITATION, LOST PROFIT DAMAGES ARISING FROM YOUR USE OF OR
INABILITY TO USE THE SERVICE, EVEN IF CREDOVITA HAS BEEN ADVISED OF
THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
CONTRARY CONTAINED HEREIN, CREDOVITA’S LIABILITY TO YOU OR ANY THIRD
PARTY FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE
ACTION, WILL AT ALL TIMES BE LIMITED TO DIRECT DAMAGES, NOT TO
EXCEED $150. THE FOREGOING LIMITATIONS OF LIABILITY WILL APPLY TO
THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION.
10. CREDOVITA INDEMNITY AND RELEASE
You agree to indemnify and hold Credovita and its Affiliates,
harmless from any loss, liability, claim, or demand, including
reasonable attorneys' fees, arising out of or relating to (a) your
use of or access to the Service, (b) your breach of this Terms of
Service or your violation of applicable law, including any laws
applicable to the entry into a Loan through the Service (c) any User
Content that you post on, or otherwise submit to, the Service, (d)
your acts and omissions, including without limitation, your failure
to repay a Loan as agreed in the agreement entered into on the
Service to fund a Loan, or (e) your violation of the rights of any
third party. Credovita reserves the right, at your expense, to
assume the exclusive defense and control of any matter for which you
are required to indemnify Credovita and you agree to (i) cooperate
with our defense of these claims and (ii) not to settle any matter
without Credovita’s prior written consent. To the fullest extent
permitted by law, the foregoing indemnity will apply regardless of
any fault, negligence, or breach of warranty or contract of
Credovita or its Affiliates.
11. ARBITRATION
PLEASE READ THIS SECTION 11 VERY CAREFULLY AS IT WILL HAVE A
SUBSTANTIAL IMPACT ON HOW LEGAL CLAIMS THAT YOU AND WE HAVE AGAINST
EACH OTHER ARE RESOLVED.
a. ARBITRATION PROVISION.
YOU HAVE THE RIGHT TO REJECT THIS ARBITRATION PROVISION AS SET FORTH
BELOW. If you do not reject this Arbitration Provision, for a Claim
(defined in subsection (c) below) subject to arbitration, neither
you nor we will have the right to: (1) have a court or a jury decide
the Claim; (2) engage in information-gathering (discovery) to the
same extent as in court; (3) participate in a class action, private
attorney, counsel, or the like in general or other representative
action in court or in arbitration; or (4) join or consolidate a
Claim with claims of any other person. The right to appeal is more
limited in arbitration than in court and other rights in court may
be unavailable or limited in arbitration.
b. Special Definition of "We," "Us" and "Our."
Solely for purposes of this Section 11, the terms "we," "us" and
"our," in addition to the meanings set forth in this Terms of
Service, also refer to our employees, officers, directors, partners,
controlling persons, subsidiaries, affiliates, successors and
assigns. "We," "us" and "our" also apply to third parties if you
assert a Claim against such third parties in connection with a Claim
you assert against us.
c. Claims Subject to Arbitration.
A "Claim" subject to arbitration is any claim, dispute or
controversy between you and us (other than an Excluded Claim or
Proceeding as set forth below), whether preexisting, present or
future, which arises out of or relates to this Terms of Service, any
User Content or Credovita Content, any agreements that you enter
into as a result of using the Service, and any dispute that you may
have relating to another user. "Claim" has the broadest possible
meaning and includes initial claims, counterclaims, cross-claims,
interpleaders, third-party claims and federal, state, local and
administrative claims and claims which arose before the effective
date of this Section 11. It includes disputes based upon contract,
tort, consumer rights, fraud and other intentional torts,
constitution, statute, regulation, ordinance, common law and equity
and includes claims for money damages and injunctive or declaratory
relief. Upon the demand of you or us, Claim(s) will be resolved by
individual (not class or class-wide) binding arbitration in
accordance with the terms specified in this Section 11.
d. Excluded Claim or Proceeding.
Notwithstanding the foregoing, "Claim" does not include: (A) Any
dispute or controversy about the validity, enforceability, coverage
or scope of this Section 11 or any part thereof (including, without
limitation, the Class Action Waiver set forth below and/or this
sentence); all such disputes or controversies are for a court and
not an arbitrator to decide. However, any dispute or controversy
that concerns the validity or enforceability of the rules and
regulations as a whole is for the arbitrator, not a court, to
decide; (B) Your or our right to resort to self-help remedies such
as the right of setoff, to interplead funds in the event of a
dispute, to exercise any security interest or lien held in property,
or to comply with legal process, or to obtain provisional remedies
such as injunctive relief, attachment, or garnishment by a court
having appropriate jurisdiction; or (C) Any individual action in
court by one party that is limited to preventing the other party
from using a self-help remedy and that does not involve a request
for damages or monetary relief of any kind. The institution and/or
maintenance of any such right, action or litigation shall not
constitute a waiver of the right of either of the parties to compel
arbitration regarding any other dispute subject to arbitration
pursuant to this Section 11. Moreover, this Section 11 will not
apply to any Claims that are the subject of a class action filed in
court that is pending as of the effective date of this Section 11 in
which you are alleged to be a member of the putative class for as
long as such class action is pending.
e. Right to Reject Arbitration Provision.
You may reject this Section 11 and therefore not be subject to being
required to resolve any claim, dispute or controversy by
arbitration. To reject this Section 11, you must send us written
notice of your decision so that we receive it at the address listed
below within forty-five (45) days of the opening of your account.
Such notice must be sent by certified mail, return receipt
requested, and must include a statement that you wish to reject
Section 11 of this Terms of Service along with your name, address,
account name, account number and your signature and must be mailed
to: LoanWell, LLC, Attn: Arbitration. 201 West Main Street, Durham,
NC 27701. This is the sole and only method by which you can reject
this Section 11. Rejection of this Section 11 will not affect any
remaining terms of this Terms of Service and will not result in any
adverse consequence to you or your account. You agree that our
business records will be final and conclusive with respect to
whether you rejected this Section 11 in a timely and proper fashion.
This Section 11 will apply to you and us and to your account unless
you reject it by providing proper and timely notice as stated
herein.
f. Class Action Waiver.
Notwithstanding any other provision of this Terms of Service, if
either you or we elect to arbitrate a Claim, neither you nor we will
have the right: (a) to participate in a class action, private
attorney general action or other representative action in court or
in arbitration, either as a class representative or class member; or
(b) to join or consolidate Claims with claims of any other persons
("Class Action Waiver"); provided, however, that the Class Action
Waiver does not apply to any lawsuit or administrative proceeding
filed against us by a state or federal government agency even when
such agency is seeking relief on behalf of a class of borrowers
including you. This means that we will not have the right to compel
arbitration of any claim brought by such an agency. No arbitrator
shall have authority to conduct any arbitration in violation of this
provision or to issue any relief that applies to any person or
entity other than you and/or us individually. The parties to this
Terms of Service acknowledge that the Class Action Waiver is
material and essential to the arbitration of any dispute between the
parties and is non-severable from this Section 11. If the Class
Action Waiver is limited, voided or found unenforceable, then this
Section 11 (except for this sentence) shall be null and void with
respect to such proceeding, subject to the right to appeal the
limitation or invalidation of the Class Action Waiver. The parties
acknowledge and agree that under no circumstances will a class
action be arbitrated.
g. Arbitration Procedures.
If you or we elect to arbitrate a Claim, the electing party must
notify the other party in writing. This notice can be given after
the beginning of a proceeding and can be given in papers filed in
the proceeding. Otherwise, your notice must be sent to Credovita
S.A.S., Attn: Arbitration and Legal. 29, Boulevard Grande-Duchesse
Charlotte, Luxembourg City L-1331 and our notice must be sent to the
most recent email address for you in our files. You may choose
whether the hearing takes place in person, by telephone, or solely
on the basis of documents submitted to the arbitrator. If you choose
an in-person hearing, it will take place in the county/parish of
your billing address. If a party files a lawsuit in court asserting
Claim(s) that are subject to arbitration and the other party files a
motion to compel arbitration with the court which is granted, it
will be the responsibility of the party prosecuting the Claim(s) to
select an arbitration administrator in accordance with the paragraph
below and commence the arbitration proceeding in accordance with the
administrator's rules and procedures.
h. Administration.
No company may serve as administrator, without the consent of all
parties, if it adopts or has in place any formal or informal policy
that is inconsistent with and purports to override the terms of the
Class Action Waiver in this Section 11. In the event of a conflict
between the provisions of this Section 11, on the one hand, and any
applicable rules of administrator used or any other terms of this
Terms of Service, on the other hand, the provisions of this Section
11 shall control.
i. Arbitrator Rights and Responsibilities.
A single arbitrator will be appointed by the administrator and must
be a practicing attorney with ten or more years of experience or a
retired judge or similar qualified person to be appointed at the
discretion of the administrator. The arbitrator will not be bound by
judicial rules of procedure and evidence that would apply in a
court, nor by state or local laws that relate to arbitration
proceedings. The arbitrator will apply the same statutes of
limitation and privileges that a court would apply if the matter
were pending in court. The arbitrator will take reasonable steps to
protect customer account information and other confidential
information if requested to do so by you or us. You or we may choose
to be represented by counsel. In determining liability or awarding
damages or other relief, the arbitrator will follow the applicable
substantive law, consistent with the relevant regulations that would
apply if the matter had been brought in court. The arbitrator may
award any damages or other relief or remedies that would apply under
applicable law to an individual action brought in court, including,
without limitation, punitive damages (which shall be governed by the
Constitutional or Regulatory standards employed by the courts) and
injunctive, equitable and declaratory relief (but only in favor of
the individual party seeking relief and only to the extent necessary
to provide relief warranted by that party's individual claim).
j. Arbitration Fees and Costs.
You are responsible for paying any fees necessary by law or the
administrator's rules for this arbitration. However, the
administrator may have a procedure whereby you can seek a waiver of
fees charged to you by the administrator and arbitrator. We will
always pay any fees or expenses that we are required to pay by law
or the administrator's rules or that we are required to pay for this
Section 11 to be enforced. The arbitrator will have the authority to
award fees and costs of attorneys, witnesses and experts to the
extent permitted by this Terms of Service, the administrator's rules
or applicable law. However, with respect to Claim(s) asserted by you
in an individual arbitration, we will pay your reasonable attorney,
witness and expert fees and costs if and to the extent you prevail,
if applicable law requires us to or if we must bear such fees and
costs in order for this Section 11 to be enforced. At the timely
request of either party, the arbitrator shall write a brief
explanation of the grounds for the decision. A judgment on the award
may be entered by any court having jurisdiction.
k. Severability and Survival.
If any part of this Section 11, other than the Class Action Waiver,
is deemed or found to be unenforceable for any reason, the remainder
shall be enforceable. This Section 11 shall survive the closing of
your account and the termination of any relationship between us,
including the termination of this Terms of Service, any bankruptcy
to the extent consistent with applicable bankruptcy law, changes to
your Terms of Service or any related services we provide, and the
transfer or assignment of your account or any related services we
provide.
l. Effect of Arbitration Award.
The arbitrator's award shall be final and binding on all parties,
except for any right of appeal provided by the relevant regulations.
However, subject to Section 9 of this Terms of Service, if the
amount in controversy exceeds $50,000, you or we can, within 14 days
after the entry of the award by the arbitrator, appeal the award to
a three-arbitrator panel administered by the Administrator. The
panel shall reconsider anew any aspect of the initial award
requested by the appealing party. The decision of the panel shall be
by majority vote. Reference in this Section 11 to "the arbitrator"
shall mean the panel if an appeal of the arbitrator's decision has
been taken. The costs of such an appeal will be borne in accordance
with this paragraph. Any final decision of the appeal panel is
subject to judicial review only as provided under the relevant
regulations. A judgment on the award may be entered by any court
having jurisdiction.
m. Notice and Cure, Special Payment.
Prior to initiating a Claim, you may give us a written notice of
your Claim ("Claim Notice") describing the basis of your Claim and
the amount you would accept in resolution of the Claim, and a
reasonable opportunity, not less than 30 days, to resolve the Claim.
Such a Claim Notice must be sent to us by certified mail, return
receipt requested, at Credovita S.A.S., Attn: Arbitration and Legal.
29, Boulevard Grande-Duchesse Charlotte, Luxembourg City L-1331.
This is the sole and only method by which you can submit a Claim
Notice.
n. Claim Notice.
If (i) you submit a Claim Notice in accordance with subsection (n)
above on your own behalf (and not on behalf of any other party);
(ii) you cooperate with us by promptly providing the information we
reasonably request; (iii) we refuse to provide you with the relief
you request before an arbitrator is appointed; and (iv) the matter
then proceeds to arbitration and the arbitrator subsequently
determines that you were entitled to such relief (or greater
relief), you will be entitled to a maximum award $150, consistent
with Section 9 of this Terms of Service (not including any
arbitration fees and attorney's' fees and costs to which you will
also be entitled). We encourage you to address all Claims you have
in a single Claim Notice and/or a single arbitration. Accordingly,
this $150 maximum award is a single award that applies to all Claims
you have asserted or could have asserted in the arbitration, and
multiple awards of $150 are not contemplated.
o. WAIVER OF JURY TRIAL AND CLASS ACTION WAIVER.
To the extent permitted by applicable law, with respect to any Claim
or other dispute between you and us (as defined in this Section 11)
that is tried in court rather than resolved by arbitration, you and
we hereby agree (a) that the Claim or other dispute will be tried by
a judge without a jury, and you and we knowingly, voluntarily,
intentionally and irrevocably waive the right to trial by jury in
such a proceeding and (b) that any such litigation will proceed in
court on an individual basis and will not proceed as part of a class
action.This Terms of Service addresses your rights and obligations
with respect to the Service and describes the acceptable use of the
Service by you as well as any applicable restrictions. In the course
of using the Service, you may also enter into agreements that
provide you with additional rights and obligations not covered by
this Terms of Service. We encourage you to keep copies of all
relevant agreements by downloading them or printing them out. Please
see Credovita’s Privacy Policy for more information about how we
collect, use, and share information on the Service.
Credovita may modify this Terms of Service at any time and such
modification will be effective upon posting by Credovita on the Site
or any other means to dissemination to the public and its users. You
agree to be bound by any changes to this Terms of Service when you
use the Service after any such modification is posted. It is
therefore important that you review this Terms of Service regularly
to ensure you are updated as to any changes. If you do not agree
with any of the terms of this Terms of Service, you must immediately
discontinue your use of the Service.
In the event of any conflict or inconsistency between this Terms of
Service, the Privacy Policy, any other agreements you may enter into
through the Service, and any other terms and/or conditions that may
be posted at any time on the Service or otherwise communicated to
you, we reserve the right to use our sole discretion to resolve such
conflicts or inconsistencies through further communications with
you.
IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS, REMEDIES AND
OBLIGATIONS.
THIS TERMS OF SERVICE, THE CREDOVITA PRIVACY POLICY, AND ALL OTHER
TERMS AND CONDITIONS POSTED ON OUR SERVICE OR OTHERWISE COMMUNICATED
TO YOU BY US, SET OUT THE TERMS ON WHICH CREDOVITA OFFERS YOU ACCESS
TO AND USE OF THE SERVICE. YOU AGREE TO COMPLY WITH ALL THE ABOVE
WHEN ACCESSING AND USING OUR SERVICE.
YOUR USE OF THE SERVICE ESTABLISHES AN ENFORCEABLE AGREEMENT BETWEEN
YOU AND CREDOVITA. IF YOU DO NOT ACCEPT THESE TERMS OF SERVICE, YOU
CANNOT USE THE SERVICE.
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
Privacy Policy and Data Privacy Compliance Notice
(Ver 1.0 | 27 December 2019)
Credovita S.A.S. — Credovita Flapp
This is the Privacy Statement and Policy (“Privacy Statement”) for
Credovita S.A.S. and its affiliates ("Credovita"). This Privacy
Policy was last updated in December 2019.
Credovita understands that your privacy is important. Credovita is
committed to protecting your privacy and personal information you
provide or as you access and use materials on credovita.io / flapsmatch.credovita.io (the "the Site"), including the Site subscription
pages or other websites or apps that post a link to this Privacy
Statement. In addition, information that you submit to Credovita in
response to an email request for information or other outreach from
Credovita.
Credovita may, in its discretion, amend this Privacy Statement from
time to time. To ensure you are able to remain informed about the
information we collect and how we use it, material changes to our
statement will be reflected here. This Site may contain links to
external sites which are not governed by this Privacy Statement.
Credovita does not take responsibility for the privacy practices of
any third party sites to which we link. We encourage you to review
the privacy policies of any such sites before you submit information
there.
YOUR ACCEPTANCE OF THIS PRIVACY STATEMENT
Please read this Privacy Statement carefully. By browsing our
website and expressly consenting where required (for instance, when
submitting your application), you agree to be bound by this Privacy
Statement.
INFORMATION THAT WE COLLECT, AND HOW WE USE IT
What information do we collect?
Credovita collects information from you when you create your account
for the Site, request copies of publications, subscribe for email
newsletters and press releases, seek additional information
regarding our services or employment opportunities, databases, or
register for conferences and other Credovita-sponsored events. If
you do not provide such information, you will not be able to create
an account for the Site, request copies of publications, subscribe
for email newsletters and press releases, seek additional
information regarding our services or employment opportunities.
Personal information that we collect includes but is not limited to:
names, addresses, e-mail addresses, phone numbers, unique personal
identifiers, financial information, subject areas of interest and/or
demographic information, but are not strictly limited to the
following stated above
In addition, we sometimes aggregate demographic information and the
types of systems and browsers of users Credovita also may conduct
user surveys on the Web or use technologies to provide Credovita
with information on a number of areas, such as user identity, user
viewing habits, whether or not users found what they were searching
for, whether the Site content is relevant to user needs, and the
like.
How do we use personal information?
The purposes and uses of your personal information will depend on
the use of the Site and the personal information provided. We
process your personal information:
(i) for the purposes of safeguarding the legitimate interests
pursued by Credovita. This includes:
Informing you about updates to the service and notifying you about
other products and services offered by Credovita that may be of
interest to you, including information regarding publications and
events
Tailoring your experience at the Site with relevant Credovita
materials
Understanding the Site’s user population, identifying subject areas
of interest, and determining whether the Site is designed to work
with the computer settings of a majority of our visitors
Measuring and improving the effectiveness of Credovita marketing
programs across different channels.
Improving our web content and navigation.
(ii) on the basis of your consent. Insofar as you have granted us
consent to the processing of personal information for specific
purposes (for example, your application form for employment with
Credovita), the lawfulness of such processing is based on your
consent. You may withdraw your consent at any time.
(iii) for compliance with a legal obligation. This includes antifraud and anti-money laundering measures as well as tax and social
security requirements.
We will not sell, share, or rent or otherwise make available your
personal information to other parties, except that we may disclose
the information to third parties who perform services on our behalf
and have a need to access the information in connection with those
services. Any third parties will only process this information to
the extent to which and within the limits that Credovita itself is
permitted to process that data. In addition, Credovita may disclose
your contact information in response to inquiries by bona-fide
rights owners in connection with allegations of infringement of
copyright or other proprietary rights arising from information that
you have posted on the Site or otherwise provided to Credovita.
HOW WE MIGHT SHARE YOUR INFORMATION
The third parties with whom we may need to share personal
information to help us provide services and products to you and to
run our Website include:
our subsidiaries or affiliates; our advisors; our third party
service providers who process information on our behalf to help run
some of our internal business operations including email
distribution, IT services and marketing and events services; our
business partners for publications and events co-organized by
Credovita and them; law enforcement bodies in order to comply with
any legal obligation or court order.
Because Credovita is a global organisation we need to transfer
personal information which is collected on the Site or through other
means across the Credovita group of companies and affiliates to help
operate our business efficiently. This also includes third parties
located in different countries around the world, including outside
of the EEA. These arrangements may involve your personal information
being located in various countries around the world e.g. USA where
privacy laws differ. We only make these arrangements or transfers
where we are satisfied that adequate levels of protection are in
place to protect information held in that country. In addition, the
Site may be viewed and accessed anywhere in the world including
countries that may not have laws regulating the use and transfer of
personally identifiable information. By using the Site, submitting
information through this site, or submitting personal information to
BCG through other means you voluntarily consent to such
international transfer and hosting of such information to those
countries and parties.
RETENTION OF YOUR PERSONAL INFORMATION
Credovita retains your personal information for so long as is
necessary to fulfil the purpose for which it was collected. We may
retain your personal information for longer if they may be the
subject of a legal claim, or may otherwise be relevant for future
litigation.
MARKETING
If, at any time, you prefer not to receive further communications
from us in any or all forms you will have the ability to unsubscribe
from such communications by means of a link provided in every e-mail
that is sent to you by us. When subscribing to BCG e-mail
newsletters, you are given the opportunity to select which
promotions, news, and information you would like to receive at the
time of sign up, and you will have the opportunity to unsubscribe
from such communications.
COOKIES AND OTHER TRACKING TECHNOLOGIES
Credovita may use cookies on this Site and in our communications
with you to keep track of your visit to our Site and our
communications with you. A “cookie” is a small amount of data sent
from a Web server to your browser and stored on your computer’s hard
drive. Other tracking technologies work similarly to cookies and
place a small amount of data on your devices to monitor your website
activity to allow us to collect information about how you use our
Site and our services. With most internet browsers, you can erase
cookies from your computer hard drive, block all cookies, or receive
a warning before a cookie is stored on your computer. Please refer
to your browser instructions or you can visit https://
www.aboutcookies.org/ which will give you more information. Once you
have given your consent to use cookies we shall store a cookie on
your computer or device to remember this for next time. If you wish
to withdraw consent at any time you will need to delete our cookies
using your web browsers settings. Please be advised that certain
sections or functionalities of the Site may be inaccessible to you
if your browser does not accept cookies.
We use the following types of cookies:
“persistent cookies” to improve your experience when using the Site.
“session cookies” to enable your use of our Site and to remember
your settings. Session cookies are deleted automatically at the end
of your visit.
“web analytics cookies”. These cookies are used by us or third-party
providers to analyze how the Site and our services are used,
including the following types:
Google Analytics. This website uses Google Analytics, a web
analytics service provided by Google, Inc. ("Google"). Google
Analytics uses "cookies" to help the website analyze how users use
the site. The information generated by the cookie about your use of
the website (including your IP address) will be transmitted to and
stored by Google on servers in the United States. Google uses this
information to evaluate your use of the website, compiling reports
on website activity for website operators and providing other
services relating to website activity and internet usage. Google may
also transfer this information to third parties where required to do
so by law, or where such third parties process the information on
Google's behalf. Google will not associate your IP address with any
other data held by Google. You may refuse the use of cookies by
selecting the appropriate settings on your browser, however please
note that if you do this you may not be able to use the full
functionality of this website. By using this website and accepting
the use of the cookies, you consent to the processing of data about
you by Google in the manner and for the purposes set out above. To
find out more about Google Analytics, Google's privacy policy and
opting out of its cookies please visit: https://tools.google.com/
dlpage/gaoptout.
Web beacons. Credovita includes a web beacon, which is a graphic
image, in a majority of the HTML email messages we send. Credovita
uses web beacons, alone or in conjunction, with cookies to compile
information about your usage of Credovita websites and interaction
with emails from Credovita. We use the capability to determine
whether or not an email has been received, opened, or when an URL
has been clicked inside of an email that directs you to one of
Credovita websites. These web beacons are used to: (i) operate and
improve Credovita websites, services, and email communications, (ii)
send emails in a format users can read and (iii) track the aggregate
number of emails opened. The web beacon does not collect your
personal information, however the information compiled by the web
beacon allows us to tie a user to information Credovita has
collected in data collection process as set out in this Privacy
Statement. You may refuse the use of web beacons by selecting the
appropriate settings on your email program to disable image and
refraining from clicking on any links in email messages.
SECURITY PROCESSES
Credovita has in place appropriate technological and operational
security processes designed to protect personally identifiable
information from loss, misuse, alteration or destruction. Only
authorised employees and contractors will have access to any data
provided by you, and that access is limited by need. Each employee
or contractor having access to any personally-identifiable
information is obligated to maintain its confidentiality. Although
we take steps that are generally accepted as industry standard to
protect your personally-identifiable information, Credovita cannot
guarantee that your personally-identifiable information will not
become accessible to unauthorized persons and Credovita cannot be
responsible for any actions resulting from a breach of security when
information is supplied over the internet or any public computer
network.
LINKS TO OTHER WEB SITES
This website contains links to other Web sites not operated by
Credovita.
Credovita is not responsible for the privacy practices or the
content of any non-Credovita web sites to which we link from the
Site. We are not responsible for the protection and privacy of any
information you provide whilst visiting other websites and sites not
governed by our Privacy Statement. We cannot control the content or
security of such websites. We cannot be held responsible for any
loss or damage incurred by a user as a result of visiting such
websites. No links are intended to be, nor should be construed as,
an endorsement of any kind by us of that other website.
COMPLIANCE WITH LAW
BCG complies with all applicable privacy laws and regulations.
Credovita may be compelled to surrender personal user or customer
information to legal authorities if presented with a court subpoena
or similar legal or administrative order, or as required or
permitted by the laws, rules and regulations of any nation, state or
other applicable jurisdiction. Also, in the event of a violation of
the terms and conditions of use of the Site or a violation of any
restrictions on use of materials provided in or through the Site, we
may disclose personal user information to our affected business
partners or legal authorities.
ACCESS RIGHTS
In accordance with applicable data protection laws, including but
not limited to the GDPR, you have a right to request a copy of the
personal information we hold about you and details of how we use
that information. If any of the information held about you is
incorrect or out of date, you have the right to amend or rectify it,
please follow the process outlined below and we will amend our
records where appropriate. You also have the right to require us to
erase your personal data, stop processing your personal data,
restricting the processing of your personal information, right of
portability of your personal information and/or to withdraw your
consent to processing. This may not apply if there are other legal
justifications to continue processing. If you think we may have
incorrect personal information, or would like a copy of the personal
information we hold on you, or to exercise any other data protection
right, please contact us. Please note that we need you to prove who
you are before we can provide you with any information.
You also have a right to lodge a complaint with a relevant
supervisory authority.
CHILDREN
Credovita understands the importance of protecting children's
privacy, particularly in their online interactions. This Site is not
designed for and does not intentionally target or solicit to
children 18 years of age and younger.
USE OF CREDOVITA WEB SITES
Your access to and use of the Site are subject to this Privacy
Statement and certain other terms and conditions, contained in our
Terms of Service.
CONTACT US
For further questions you may contact the appropriate data
protection point of contact: dpo@credovita.io
        </pre>
    </div>
</template>

<script>
    export default {
        name: "ToS"
    }
</script>

<style scoped>
    pre {
        text-align: left;
        white-space: pre-wrap;       /* Since CSS 2.1 */
        white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
        white-space: -pre-wrap;      /* Opera 4-6 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
    }
</style>